import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=5524bf1e&scoped=true&"
import script from "./ErrorBox.vue?vue&type=script&lang=ts&"
export * from "./ErrorBox.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBox.vue?vue&type=style&index=0&id=5524bf1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5524bf1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
